export const SLOT_NAME = 'additionalTimeSlot';

declare function OnAddBookings(bookingIds: string[]): void;

export type AdditionalTimeSlot$w = {
  bookingIds: string[];
  onAddBookings: (onAddBookings: typeof OnAddBookings) => void;
};
